module.exports = __webpack_public_path__ + "static/img/fish19.309c6a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/flydragonfish/fish19.png
// module id = sQFV
// module chunks = 0